import { LOCATION_RESOURCES } from "../actions/types";

export default (state = {}, action) => {
  switch (action.type) {
    case LOCATION_RESOURCES:
      return action.payload;
    default:
      return state;
  }
};
